<template>
  <div class="statistics w-full h-full box-border">
    <div class="card h-full box-border bg-white shadow-theme rounded">
      <div v-if="userInfo.isQY" class="card-body">
        <ul class="border-b border-solid" style="border-color: #e7e9eb">
          <router-link
            v-for="menu in menus"
            tag="li"
            :to="menu.path"
            :key="menu.meta.id"
            class="cursor-pointer leading-22 text-theme-black-650 text-medium inline-block px-6 py-3"
          >
            {{ menu.meta.label }}
          </router-link>
        </ul>

        <div class="main-box w-full h-full box-border" style="overflow: auto">
          <router-view></router-view>
        </div>
      </div>
      <div v-else class="main-box w-full h-full box-border" style="overflow: auto">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex' 

export default {
  name: 'Statistics',
  data() {
    return {}
  },
  computed:{
    ...mapGetters(['userInfo']),
  },
  methods: {},
  created() {
    this.menus = this.$dygcRouter.getChildrenByName('settlement-initiated')
  },
  mounted(){
    // console.log(this.userInfo,'9999')
  }
}
</script>

<style lang="scss" scoped>
.statistics {
  .router-link-active {
    @apply text-theme border-theme border-b-2 border-solid;
  }

  .card .card-body {
    height: calc(100% - 50px);
  }
}
</style>
